import { render } from "./PedidoTable.vue?vue&type=template&id=4b31255a"
import script from "./PedidoTable.vue?vue&type=script&lang=js"
export * from "./PedidoTable.vue?vue&type=script&lang=js"

import "./PedidoTable.vue?vue&type=style&index=0&id=4b31255a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__